import react from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Resumen from "./pages/Resumen"
import Configuracion from "./pages/Configuracion"
import Plantillas from "./pages/Plantillas"
import PlantillasCoexistencia from "./pages/PlantillasCoexistencia"
import MensajesCoexistencia from "./pages/MensajesCoexistencia"
import PlantillasRouter from "./pages/PlantillasRouter"
import IntegracionesSelector from "./pages/IntegracionesSelector"
import NotFound from "./pages/NotFound"
import ProtectedRoute from "./components/ProtectedRoute"
import Mensajes from "./pages/Mensajes"
import Calendario from "./pages/Calendario"
import WhatsappConnect from "./pages/WhatsappConnect"
import Contactos from "./pages/Contactos"
import WhatsappGroupContacts from "./pages/WhatsappGroupContacts"
import AlimentarBD from "./pages/AlimentarBD"
import Soporte from "./pages/Soporte"
import LeadCapture from "./pages/LeadCapture"
import AgenteIA from "./pages/AgenteIA"
import ForgotPassword from "./pages/ForgotPassword"
import ResetPassword from "./pages/ResetPassword"
import DemoWizard from "./pages/DemoWizard"
import { SendManagerProvider } from "./context/SendManagerContext"
import SendBanner from "./components/SendBanner"
import AdminBanner from "./components/AdminBanner"
import WaveSalesLanding from "./pages/WaveSalesLanding"
import PaidGate from "./components/PaidGate"
import { ACCESS_TOKEN, REFRESH_TOKEN } from "./constants"
import Renovacion from "./pages/Renovacion"
import PlanExpiredPopup from "./components/PlanExpiredPopup"
import RestrictedGuard from "./components/RestrictedGuard"
import TerminosCondiciones from "./pages/TerminosCondiciones"
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad"
import PoliticaCookies from "./pages/PoliticaCookies"
import EmbeddedEvents from "./pages/EmbeddedEvents"
import AboutWaveSales from "./pages/AboutWaveSales"
import Roadmap from "./pages/Roadmap"

function Logout() {
  try {
    localStorage.removeItem(ACCESS_TOKEN)
    localStorage.removeItem(REFRESH_TOKEN)
    localStorage.removeItem("username")
    // Limpiar evidencia de pago local para evitar acceso indebido a /register
    localStorage.removeItem('ws_paid')
  } catch {}
  return <Navigate to="/login" />
}

function RegisterAndLogout() {
  // Importante: NO borrar la bandera de pago (ws_paid)
  try {
    localStorage.removeItem(ACCESS_TOKEN)
    localStorage.removeItem(REFRESH_TOKEN)
    localStorage.removeItem("username")
  } catch {}
  return <Register />
}

function App() {
  return (
    <BrowserRouter>
      <RestrictedGuard />
      <SendManagerProvider>
      <Routes>
        {/* Landing pública en raíz */}
        <Route path="/" element={<WaveSalesLanding />} />
        <Route path="/nosotros" element={<AboutWaveSales />} />
        {/* Páginas de políticas públicas */}
        <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
        <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
        {/* Dashboard protegido movido a /resumen */}
        <Route
          path="/resumen"
          element={
            <ProtectedRoute>
              <Resumen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plantillas"
          element={
            <ProtectedRoute>
              <PlantillasRouter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plantillas-coexistencia"
          element={
            <ProtectedRoute>
              <PlantillasCoexistencia />
            </ProtectedRoute>
          }
        />
        <Route
          path="/integraciones"
          element={
            <ProtectedRoute>
              <IntegracionesSelector />
            </ProtectedRoute>
          }
        />
        <Route
          path="/integraciones/eventos"
          element={
            <ProtectedRoute>
              <EmbeddedEvents />
            </ProtectedRoute>
          }
        />
        {/* Ruta WhatsApp QR deshabilitada temporalmente: redirige a Integraciones */}
        <Route
          path="/whatsapp"
          element={
            <ProtectedRoute>
              <Navigate to="/integraciones" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mensajes"
          element={
            <ProtectedRoute>
              <Mensajes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mensajes-coexistencia"
          element={
            <ProtectedRoute>
              <MensajesCoexistencia />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agente-ia"
          element={
            <ProtectedRoute>
              <AgenteIA />
            </ProtectedRoute>
          }
        />
        <Route
          path="/calendario"
          element={
            <ProtectedRoute>
              <Calendario />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contactos"
          element={
            <ProtectedRoute>
              <Contactos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roadmap"
          element={
            <ProtectedRoute>
              <Roadmap />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contactos/whatsapp"
          element={
            <ProtectedRoute>
              <WhatsappGroupContacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/conexion"
          element={
            <ProtectedRoute>
              <AlimentarBD />
            </ProtectedRoute>
          }
        />
        <Route
          path="/soporte"
          element={
            <ProtectedRoute>
              <Soporte />
            </ProtectedRoute>
          }
        />
        <Route path="/capturar/:code" element={<LeadCapture />} />
        <Route path="/login" element={<Login />} />
  <Route path="/demo" element={<DemoWizard />} />
  <Route path="/forgot-password" element={<ForgotPassword />} />
  <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/logout" element={<Logout />} />
          <Route path="/renovacion" element={<Renovacion />} />
        <Route path="/register" element={<PaidGate><RegisterAndLogout /></PaidGate>} />
        <Route
          path="/configuracion"
          element={
            <ProtectedRoute>
              <Configuracion />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <SendBanner />
      <PlanExpiredPopup />
      <AdminBanner />
      </SendManagerProvider>
    </BrowserRouter>
  )
}

export default App
